import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesLinktypesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-linktypes-delete',
	path: '/secure/admin/DeleteLinkType!default.jspa',
};
